var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-space-between"},[_c('div',{staticClass:"d-flex align-center flex-grow-1",style:({
      cursor: _vm.currentPage == 1 ? 'not-allowed' : 'pointer',
      opacity: _vm.currentPage == 1 ? 0.27 : 1,
      flexBasis: 0
    }),on:{"click":_vm.decrementPage}},[_c('Arrow',{staticClass:"left",style:({ marginRight: '4px' }),attrs:{"borderWidth":"1px","width":"4px"}}),_c('div',{staticClass:"text-p3"},[_vm._v(_vm._s(_vm.$t('PreviousMsg')))])],1),(_vm.totalPages !== 0 && _vm.totalPages !== 1)?_c('div',{staticClass:"text-p5"},[_vm._v(" "+_vm._s(_vm.currentPage)+" of "+_vm._s(_vm.totalPages)+" ")]):_vm._e(),_c('div',{staticClass:"d-flex align-center flex-grow-1 justify-end",style:({
      cursor:
        _vm.currentPage == _vm.totalPages || _vm.totalPages === 0
          ? 'not-allowed'
          : 'pointer',
      opacity: _vm.currentPage == _vm.totalPages || _vm.totalPages === 0 ? 0.27 : 1,
      flexBasis: 0
    }),on:{"click":_vm.incrementPage}},[_c('div',{staticClass:"text-p3"},[_vm._v(_vm._s(_vm.$t('NextMsg')))]),_c('Arrow',{staticClass:"right",style:({ marginLeft: '4px' }),attrs:{"borderWidth":"1px","width":"4px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }